import { render, staticRenderFns } from "./long-list.vue?vue&type=template&id=44e02534&"
import script from "./long-list.vue?vue&type=script&lang=js&"
export * from "./long-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports